import { Autocomplete, Box, Button, CircularProgress, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import Page from '../../component/Page'
// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { MobileDatePicker } from '@mui/x-date-pickers';
import api from '../../api/api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import StockContext from './services/stockApi';
import { getBranchList, getItemMasterList } from '../setting/services/settingApi';
import { useSelector } from 'react-redux';
import { CalQtySack, GetBreedClassNo, GetSeasonNo, StockStatus } from './services/stockService';
import dayjs from 'dayjs';
import { STOCK_CONFIG } from './config';
import ConfirmDialogAdjust from './component/confirmDialogAdjust';
import ConfirmPrint from './component/confirmPrint';
import './adjustDetail.scss'
import Swal from 'sweetalert2';
import { getData } from '../../services/api';
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function AddStockAdjust() {
    const navigate = useNavigate();
    const { id } = useParams()
    const { getAdjustDetail, getZones } = useContext(StockContext);
    const { profile, loading } = useSelector(state => state.profile)
    const [open, setOpen] = useState(false);
    const [documentDate, setDocumentDate] = useState(dayjs(new Date()))
    const [adjustDate, setAdjustDate] = useState()
    const [isAddedType, setIsAddedType] = useState(true)
    const [branchs, setBranchs] = useState([])
    const [branchNo, setBranchNo] = useState()
    const [detail, setDetail] = useState()
    const [items, setItems] = useState([])
    const [name, setName] = useState('')
    const [zones, setZones] = useState([])
    const [lot, setLot] = useState([])
    const [openP, setOpenP] = useState(false);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [adjustDateError, setAdjustDateError] = useState(false);
    const [rows, setRows] = useState([
        {
            id: 0,
            ItemName: "",
            Year: '',
            Season: "",
            Lot: "",
            Qty: '',
            UnitNo: "",
            ModifiedDate: null,
            WarehouseNo: "",
            ZoneNo: "",
            SalePrice: 0,
            CostPrice: 0,
            ItemNo: null
        }
    ]);
    function addRow() {
        const newRow = {
            id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
            ItemName: "",
            Year: '',
            Season: "",
            Lot: "",
            Qty: '',
            UnitNo: "",
            ModifiedDate: null,
            WarehouseNo: "",
            ZoneNo: "",
            SalePrice: 0,
            CostPrice: 0,
            ItemNo: null
        };

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {
        const data = rows?.filter((e, index) => i !== index);
        setRows(data);
    };
    // const getBranchs = async () => {
    //     const res = await api.get(`dbms/branchs`)
    //     const data = await res.data
    //     if (data.status === true) {
    //         setBranchs(data.result)
    //     }
    // }


    const getLots = async (BranchNo, keyword, lotNumber, sumLots, setData) => {
        let _params = '';
        let _name = '';
        let _lot = '';
        let _sumLots = '';

        if (keyword) {
            _name = 'name=' + keyword + '&';
        }
        if (lotNumber) {
            _lot = 'lot=' + lotNumber + '&';
        }
        if (sumLots) {
            _sumLots = 'sumLots=' + sumLots + '&';
        }

        _params = _name + _lot + _sumLots
        const url = STOCK_CONFIG.requests.getLotsBranch.url + `/${BranchNo}/lots`;

        await getData(url, '?' + _params + 'limit=200').then((response) => {
            if (response.status === true) {
                setData(response.result.items)
            }
        })
    }
    useEffect(() => {
        if (isAddedType) {
            getItemMasterList(name, setItems)
            if (!id) {
                setRows([
                    {
                        id: 0,
                        ItemName: "",
                        Year: '',
                        Season: "",
                        Lot: "",
                        Qty: '',
                        UnitNo: "",
                        ModifiedDate: null,
                        WarehouseNo: "",
                        ZoneNo: "",
                        SalePrice: 0,
                        CostPrice: 0,
                        ItemNo: null
                    }
                ])
            }

        }
    }, [name, isAddedType])

    useEffect(() => {
        if (!isAddedType) {
            getLots(branchNo, name, null, null, setItems)
            if (!id) {
                setRows([
                    {
                        id: 0,
                        ItemName: "",
                        Year: '',
                        Season: "",
                        Lot: "",
                        Qty: '',
                        UnitNo: "",
                        ModifiedDate: null,
                        WarehouseNo: "",
                        ZoneNo: "",
                        SalePrice: 0,
                        CostPrice: 0,
                        ItemNo: null
                    }
                ])
            }
        }
    }, [name, isAddedType, branchNo])
    useEffect(() => {
        getBranchList(null, setBranchs)
        if (id) {
            getAdjustDetail(id, setDetail)

        }

    }, [])
    useEffect(() => {
        if (profile) {
            setBranchNo(profile?.BranchNo?.BranchNo)
            getZones(profile?.BranchNo?.BranchNo, setZones)
        }
    }, [profile])
    useEffect(() => {
        if (detail) {
            setAdjustDate(dayjs(detail?.AdjustDate))
            setDocumentDate(dayjs(detail?.DocumentDate))
            setBranchNo(detail?.BranchNo?.BranchNo)
            setRows(detail?.AdjustDetails)
            setIsAddedType(detail?.IsAddedType)
        }

    }, [detail])
    const handleSubmit = (s) => {
        
        const body = {
            AdjustNo: id || null,
            IsAddedType: isAddedType,
            BranchNo: branchNo,
            AdjustDate: dayjs(adjustDate).format('YYYY-MM-DD'),
            DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
            ApproveId: null,
            Status: s || 'Y',
            AdjustDetails: rows?.map((x) => (
                {
                    ...x,
                    ItemNo: x?.ItemNo?.ItemNo?.ItemNo || x?.ItemNo?.ItemNo,
                    Year: x?.Year,
                    Season: x?.ItemNo?.Season,
                    Lot: x?.LotGen ? x?.LotGen + x?.Lot : x?.Lot,
                    Qty: +x?.Qty.toString().replaceAll(',', ''),
                    UnitNo: x?.ItemNo?.UnitNo?.UnitNo,
                    ModifiedDate: dayjs(new Date()).format('YYYY-MM-DD'),
                    WarehouseNo: x?.WarehouseNo?.WarehouseNo || x?.WarehouseNo,
                    ZoneNo: x?.ZoneNo?.ZoneNo || x?.ZoneNo,
                    SalePrice: x?.ItemNo?.SalePrice.toString(),
                    CostPrice: x?.CostPrice
                }
            ))
        }
        const adjustAdd = async () => {
            setLoadingSubmit(true)
            if (body?.AdjustNo) {
                const url = STOCK_CONFIG.requests.getAdjusts.url + `/${body?.AdjustNo}`;
                const res = await api.put(url, body)
                const data = res.data
                if (data.status === true) {
                    if (body.Status === 'N') {
                        Swal.fire(
                            'ยกเลิกรายการสำเร็จ',
                            '',
                            'success'
                        )
                        navigate('/stock/stock-adjust/' + data.result.AdjustNo)
                        setOpen(false)
                        setLoadingSubmit(false)
                        getAdjustDetail(id, setDetail)
                    } else {
                        navigate('/stock/stock-adjust/' + data.result.AdjustNo)

                        setOpenP(true)
                        setOpen(false)
                        setLoadingSubmit(false)
                        getAdjustDetail(id, setDetail)
                    }

                } else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                    setLoadingSubmit(false)

                }
            } else {
                const res = await api.post(STOCK_CONFIG.requests.getAdjusts.url, body)
                const data = res.data
                if (data.status === true) {
                    navigate('/stock/stock-adjust/' + data.result?.AdjustNo)

                    setOpenP(true)
                    setOpen(false)
                    setLoadingSubmit(false)

                } else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                    setLoadingSubmit(false)

                }
            }


        }
        if (s === 'N') {
            return Swal.fire({
                title: 'ยืนยันการยกเลิก',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#4ab866',
                cancelButtonColor: '#d33',
            }).then((result) => {
                if (result.isConfirmed) {
                    adjustAdd()
                }
            })
        }
        adjustAdd()
    }
    async function downloadAdjust() {
        setLoadingPDF(true)
        const res = await api.get(STOCK_CONFIG.requests.getAdjusts.url + `/${id}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingPDF(false)
    }
    const onBlur = (e) => {
        if (!e.target.value) {
            setAdjustDateError(true)
        } else {
            setAdjustDateError(false)
        }
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <form>
                    <div class="container-fluid">
                        <div class="d-flex row align-items-center ">
                            <div class="col-6">
                                <label class="title-content mb-4">
                                    ข้อมูลปรับปรุงยอด
                                </label>
                            </div>
                            {id &&
                                <div class="col-6 text-end px-4">
                                    <Button variant='contained' className="ButtomSearch" sx={{
                                        width: '110px',
                                        background: '#3364af57 0 0 no-repeat padding-box',
                                        border: '1px solid #3364af57',
                                        color: '#3364af',
                                        fontWeight: '700',
                                        borderRadius: '100px', ':hover': {
                                            background: '#3364af57 0 0 no-repeat padding-box',
                                        }
                                    }} onClick={downloadAdjust}>{loadingPDF ? <CircularProgress size={'18px'} color="inherit" /> : 'พิมพ์'}</Button>
                                </div>
                            }

                        </div >

                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">วันที่เอกสาร</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <MobileDatePicker
                                        disabled={id ? true : false}
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={documentDate} onChange={e => setDocumentDate(e)}
                                        slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: documentDate } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">รายการ</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                                        <Select value={isAddedType} onChange={e => {
                                            setIsAddedType(e.target.value)
                                            setRows([])
                                            setItems([])
                                        }} disableUnderline >
                                            <MenuItem value={true}>ปรับปรุงเข้า</MenuItem>
                                            <MenuItem value={false}>ปรับปรุงออก</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div >

                        </div >
                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">{isAddedType ? 'วันที่รับเมล็ดพันธุ์เข้าคลัง' : 'วันที่ปรับปรุงเมล็ดพันธุ์ออก'}</label>
                                <Box className={`backgroundField ${adjustDateError ? 'error' : ''}`}>
                                    <MobileDatePicker

                                        // disabled={id ? true : false}
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={adjustDate} onChange={e => setAdjustDate(e)}
                                        slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: adjustDate, onBlur: onBlur } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />
                                </Box>
                                {adjustDateError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกเหตุผล</span>}

                            </div>
                            <div class="col-lg-4 col-sm-12">
                                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <FormControl disabled={id ? true : false} variant="standard" fullWidth >
                                        <Select value={branchNo || ''} onChange={e => setBranchNo(e.target.value)} disableUnderline >
                                            {branchs?.map((x) => (
                                                <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div >
                        </div >
                        {id && <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput">ผู้สร้าง</label><label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.CreateId} variant="standard" fullWidth disabled={id ? true : false}
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.ModifiedId} variant="standard" fullWidth disabled={id ? true : false}
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>

                        </div>}

                        <div class="d-flex row align-items-center mt-5 mb-4">
                            <div class="col-6">
                                <label class="title-content">
                                    รายการปรับปรุงเมล็ดพันธุ์ข้าว
                                </label>
                            </div>
                            {!id &&
                                <div class="col-6 text-end">
                                    <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />
                                </div>}
                        </div >
                        <div class="adjustDetail row">
                            <div class="col-md-12 table-responsive-sm " style={{ height: 'auto' }}>
                                <table class="table table-borderless  ">
                                    <thead>
                                        <tr>
                                            <th scope="col ">ที่</th>
                                            <th scope="col " class="w-300">เมล็ดพันธุ์</th>
                                            <th scope="col ">ชั้นพันธุ์</th>
                                            <th scope="col ">ฤดู</th>
                                            <th scope="col ">ชนิดข้าว</th>
                                            <th scope="col ">สารเคมี</th>

                                            <th scope="col "> ปีที่ผลิต</th>

                                            <th scope="col ">ล็อตที่</th>
                                            <th scope="col ">จำนวน (กระสอบ)</th>
                                            {id ? null : isAddedType ? null : <th scope="col ">ปริมาณก่อนปรับปรุง</th>}
                                            <th scope="col ">ปรับปรุง</th>
                                            <th scope="col ">โรงเก็บที่</th>
                                            <th scope="col ">ราคาจำหน่าย</th>
                                            <th scope="col ">ต้นทุนการผลิต</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {isAddedType ?
                                        <tbody class="">
                                            {rows?.map((x, i) => (
                                                <tr>
                                                    <td>{i + 1}.</td>
                                                    <td style={{ position: 'relative' }}>
                                                        <Autocomplete
                                                            size='small'
                                                            readOnly={id ? true : false}
                                                            options={items}
                                                            getOptionLabel={(option) => option?.ItemName}
                                                            onBlur={e => {
                                                                const item = rows?.map((v, index) => {
                                                                    v.ItemError = index === i ? x.ItemNo ? false : true : v?.ItemError;
                                                                    return v;

                                                                });
                                                                setRows([...item]);
                                                            }
                                                            }
                                                            componentsProps={{
                                                                paper: {
                                                                    sx: {
                                                                        width: 500
                                                                    }
                                                                }
                                                            }}
                                                            renderOption={(props, option) => (
                                                                <Box component="li" {...props} key={option.ItemNo}>
                                                                    {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} {option?.Chemical}
                                                                </Box>
                                                            )}
                                                            value={x?.ItemNo}
                                                            onChange={(event, newValue) => {
                                                                const branchNo = profile?.BranchNo?.BranchNo
                                                                const breedClassNo = GetBreedClassNo(x?.Option2)
                                                                const seasonNo = GetSeasonNo(x?.Season)
                                                                const lotNumber = branchNo + breedClassNo + seasonNo + x?.Year;
                                                                const item = rows?.map((v) => {

                                                                    // v.LotGen = v?.id === x?.id ? lotNumber : v?.LotGen;
                                                                    v.ItemNo = v?.id === x?.id ? newValue : v?.ItemNo;
                                                                    return v;

                                                                });
                                                                setRows([...item]);

                                                            }}

                                                            renderInput={(params) => (
                                                                <Box ref={params.InputProps.ref}>
                                                                    <OutlinedInput error={!x?.ItemError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: id ? '#e9ecef' : '#fff' }} />
                                                                </Box>
                                                            )}
                                                        />
                                                        {!x?.ItemError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute' }}>กรุณาเลือกเมล็ดพันธุ์</span>}

                                                    </td>
                                                    <td class="text-center">{x?.ItemNo?.Option2}</td>
                                                    <td class="text-center" style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}
                                                    </td>
                                                    <td class="text-center">{x?.ItemNo?.Option1}</td>
                                                    <td class="text-center">{x?.ItemNo?.Chemical}</td>


                                                    <td class="text-center">
                                                        <TextField value={x?.Year} error={!x?.YearError ? false : true}
                                                            size='small' sx={{ width: '60px', background: id ? '#e9ecef' : '#fff' }} variant='outlined' onChange={e => {
                                                                const branchNo = profile?.BranchNo?.BranchNo
                                                                const breedClassNo = GetBreedClassNo(x?.ItemNo?.Option2)
                                                                const seasonNo = GetSeasonNo(x?.ItemNo?.Season)
                                                                const lotNumber = branchNo + breedClassNo + seasonNo + e.target.value;
                                                                const item = rows?.map((v) => {
                                                                    v.Year = v?.id === x?.id ? e.target.value : v?.Year;
                                                                    v.LotGen = v?.id === x?.id ? lotNumber : v?.LotGen
                                                                    return v;

                                                                });
                                                                setRows([...item]);
                                                            }}
                                                            onBlur={e => {
                                                                const item = rows?.map((v, index) => {
                                                                    v.YearError = index === i ? x.Year.length === 2 ? false : true : v?.YearError;
                                                                    return v;

                                                                });
                                                                setRows([...item]);
                                                            }}
                                                            inputProps={{ maxLength: 2 }}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            InputProps={{
                                                                readOnly: id ? true : false
                                                            }} />
                                                    </td>

                                                    <td style={{ position: 'relative' }}>
                                                        {!id ? <>
                                                            <Box sx={{
                                                                display: 'flex', '& .MuiTextField-root': {
                                                                    color: 'red',
                                                                    '& .MuiOutlinedInput-root': { borderRadius: '0 .25rem .25rem 0' }
                                                                }
                                                            }}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: '.375rem .75rem',
                                                                    fontSize: '1rem',
                                                                    fontWeight: '400',
                                                                    lineHeight: '1.5',
                                                                    color: '#212529',
                                                                    textAlign: 'center',
                                                                    whiteApace: 'nowrap',
                                                                    backgroundColor: '#e9ecef',
                                                                    border: '1px solid #ced4da',
                                                                    borderRadius: '.25rem 0 0 .25rem',

                                                                }}>{x?.LotGen}</div>
                                                                <TextField error={!x?.LotGenError ? false : true}
                                                                    onBlur={e => {
                                                                        const item = rows?.map((v, index) => {
                                                                            v.LotGenError = index === i ? x.Lot.length === 3 ? false : true : v?.LotGenError;
                                                                            return v;

                                                                        });
                                                                        setRows([...item]);
                                                                    }}
                                                                    value={x?.Lot} size='small' fullWidth variant='outlined' onChange={e => {
                                                                        const item = rows?.map((v) => {
                                                                            v.Lot = v?.id === x?.id ? e.target.value : v?.Lot;
                                                                            return v;

                                                                        });
                                                                        setRows([...item]);
                                                                    }}
                                                                    inputProps={{ maxLength: 3 }}
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                            </Box>
                                                            {!x?.LotGenError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-16px' }}>กรุณากรอกเลขล็อต</span>}

                                                        </> :
                                                            <TextField InputProps={{
                                                                readOnly: id ? true : false
                                                            }}
                                                                sx={{ background: id ? '#e9ecef' : '#fff' }}
                                                                value={x?.LotGen ? x?.LotGen : '' + x?.Lot} size='small' fullWidth variant='outlined' />}
                                                    </td >
                                                    <td class="text-center"> {CalQtySack(x?.ItemNo?.Option2, +x.Qty.toString().replaceAll(',', '')).toLocaleString()}</td>
                                                    {/* <td class="text-center">

                                                </td > */}
                                                    <td class="text-center">
                                                        <TextField value={x?.Qty.toLocaleString()} size='small' fullWidth variant='outlined' onChange={e => {
                                                            const item = rows?.map((v) => {
                                                                let newValue = e.target.value.replace(/,/g, "");

                                                                let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                                v.Qty = v?.id === x?.id ? abc : v?.Qty;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }} />
                                                    </td>

                                                    <td>

                                                        {id ? <TextField sx={{ background: id ? '#e9ecef' : '#fff' }} InputProps={{
                                                            readOnly: id ? true : false
                                                        }} value={`${x?.WarehouseNo?.WarehouseName || x?.zones?.WarehouseNo?.WarehouseName} ${x?.ZoneNo?.ZoneName || x?.zones?.ZoneName}`} size='small' fullWidth variant='outlined' /> :
                                                            <FormControl variant="outlined" size='small' fullWidth >
                                                                <Select value={x?.ZoneNo || ''} defaultValue='' onChange={e => {
                                                                    const item = rows?.map((v) => {
                                                                        v.zones = v?.id === x?.id ? zones?.find((x) => x?.ZoneNo === e.target.value) : v?.zones;
                                                                        v.WarehouseNo = v?.id === x?.id ? zones?.find((x) => x?.ZoneNo === e.target.value).WarehouseNo?.WarehouseNo : v?.WarehouseNo;
                                                                        v.ZoneNo = v?.id === x?.id ? zones?.find((x) => x?.ZoneNo === e.target.value).ZoneNo : v?.ZoneNo
                                                                        return v;

                                                                    });
                                                                    setRows([...item]);
                                                                }}  >
                                                                    {zones?.map((z, i) => (
                                                                        <MenuItem value={z?.ZoneNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>}

                                                    </td>

                                                    <td class="text-center">
                                                        {x?.ItemNo?.SalePrice}
                                                    </td>
                                                    <td class="text-center"> {id ? parseFloat(x?.CostPrice).toFixed(2)
                                                        .replace(/\d(?=(\d{3})+\.)/g, "$&,") :
                                                        <TextField type='number' value={x?.CostPrice} size='small' fullWidth variant='outlined' onChange={e => {
                                                            const item = rows?.map((v) => {
                                                                v.CostPrice = v?.id === x?.id ? e.target.value : v?.CostPrice;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }} />}
                                                    </td>

                                                    <td>
                                                        <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />
                                                    </td >
                                                </tr >
                                            ))}


                                        </tbody > : <tbody class="">
                                            {rows?.map((x, i) => (
                                                <tr>
                                                    <td>{i + 1}.</td>
                                                    <td style={{ position: 'relative' }}>
                                                        {id ? <TextField sx={{ background: id ? '#e9ecef' : '#fff' }} InputProps={{
                                                            readOnly: id ? true : false
                                                        }}
                                                            value={x?.ItemNo?.ItemNo?.ItemName || x?.ItemNo?.ItemName} size='small' fullWidth variant='outlined' /> :
                                                            <Autocomplete
                                                                size='small'
                                                                readOnly={id ? true : false}
                                                                options={items}
                                                                getOptionLabel={(option) => option?.ItemNo?.ItemName}
                                                                onBlur={e => {
                                                                    const item = rows?.map((v, index) => {
                                                                        v.ItemError = index === i ? x.ItemNo ? false : true : v?.ItemError;
                                                                        return v;

                                                                    });
                                                                    setRows([...item]);
                                                                }
                                                                }
                                                                componentsProps={{
                                                                    paper: {
                                                                        sx: {
                                                                            width: 500
                                                                        }
                                                                    }
                                                                }}
                                                                renderOption={(props, option) => (
                                                                    <Box component="li" {...props} key={option.ItemNo.ItemNo}>
                                                                        {option?.ItemNo?.CatalogNo?.CatalogName} {option?.ItemNo?.Option2} <span style={{ color: option?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.ItemNo?.Option1} {option?.ItemNo?.Chemical}
                                                                    </Box>
                                                                )}
                                                                value={x?.ItemNo}
                                                                onChange={(event, newValue) => {

                                                                    const item = rows?.map((v, index) => {
                                                                        // v.LotGen = v?.id === x?.id ? lotNumber : v?.LotGen;
                                                                        v.ItemNo = i === index ? newValue : v?.ItemNo;
                                                                        v.Lot = i === index ? '' : v?.Lot;
                                                                        v.Year = i === index ? '' : v?.Year;
                                                                        v.Balance = i === index ? '' : v?.Balance;
                                                                        v.Balance = i === index ? '' : v?.Balance;
                                                                        v.Balance = i === index ? '' : v?.Balance;
                                                                        v.CostPrice = i === index ? 0 : v?.CostPrice;
                                                                        v.WarehouseNo = i === index ? null : v?.WarehouseNo;
                                                                        v.ZoneNo = i === index ? null : v?.ZoneNo;

                                                                        return v;

                                                                    });
                                                                    setRows([...item]);
                                                                    getLots(branchNo, newValue?.ItemNo?.ItemName, null, null, setLot)

                                                                }}

                                                                renderInput={(params) => (
                                                                    <Box ref={params.InputProps.ref}>
                                                                        <OutlinedInput error={!x?.ItemError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: id ? '#e9ecef' : '#fff' }} />
                                                                    </Box>
                                                                )}
                                                            />}
                                                        {!x?.ItemError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute' }}>กรุณาเลือกเมล็ดพันธุ์</span>}

                                                    </td>
                                                    <td class="text-center">{x?.ItemNo?.ItemNo?.Option2 || x?.ItemNo?.Option2}</td>
                                                    <td class="text-center" style={{ color: x?.ItemNo?.ItemNo?.Season === 'ฝน' || x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.ItemNo?.Season || x?.ItemNo?.Season}
                                                    </td>
                                                    <td class="text-center">{x?.ItemNo?.ItemNo?.Option1 || x?.ItemNo?.Option1}</td>
                                                    <td class="text-center">{x?.ItemNo?.ItemNo?.Chemical || x?.ItemNo?.Chemical}</td>


                                                    <td class="text-center">
                                                        {x?.Year}
                                                    </td>

                                                    <td style={{ position: 'relative' }}>
                                                        {id ? <TextField sx={{ background: id ? '#e9ecef' : '#fff' }} InputProps={{
                                                            readOnly: id ? true : false
                                                        }}
                                                            value={x?.Lot?.Lot || x?.Lot} size='small' fullWidth variant='outlined' /> : <Autocomplete
                                                            freeSolo
                                                            size='small'
                                                            options={lot}
                                                            getOptionLabel={(option) => option?.Lot}
                                                            renderOption={(props, option) => (
                                                                <Box component="li" {...props} key={option.Lot}>
                                                                    Lot: {option?.Lot} / {option?.WarehouseNo?.WarehouseName}
                                                                </Box>
                                                            )}
                                                            onBlur={e => {
                                                                const item = rows?.map((v, index) => {
                                                                    v.LotError = index === i ? x.Lot ? false : true : v?.LotError;
                                                                    return v;

                                                                });
                                                                setRows([...item]);
                                                            }
                                                            }
                                                            componentsProps={{
                                                                paper: {
                                                                    sx: {
                                                                        width: 300
                                                                    }
                                                                }
                                                            }}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            inputValue={x?.Lot || ''}
                                                            // onInputChange={(event, newInputValue) => {
                                                            //     setLotnum(newInputValue)
                                                            // }}
                                                            onChange={(event, newValue) => {
                                                                const item = rows?.map((v, index) => {
                                                                    v.Balance = i === index ? newValue?.Balance : v?.Balance;
                                                                    v.Qty = i === index ? newValue?.Qty || 0 : v?.Qty;
                                                                    v.CostPrice = i === index ? newValue?.CostPrice || 0 : v?.CostPrice;
                                                                    v.WarehouseNo = i === index ? newValue?.WarehouseNo : v?.WarehouseNo;
                                                                    v.ZoneNo = i === index ? newValue?.ZoneNo : v?.ZoneNo;
                                                                    v.ItemNo = i === index ? newValue : v?.ItemNo;
                                                                    // v.FromWarehouseNo = i === index ? newValue?.WarehouseNo?.WarehouseNo : v?.FromWarehouseNo;
                                                                    v.Lot = i === index ? newValue?.Lot : v?.Lot;
                                                                    v.Year = i === index ? newValue?.Year : v?.Year;


                                                                    return v;
                                                                });
                                                                setRows([...item]);
                                                            }}
                                                            renderInput={(params) => (
                                                                <Box ref={params.InputProps.ref}>
                                                                    <OutlinedInput error={!x?.LotError ? false : true}  {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important' }} />
                                                                </Box>)}
                                                        />}
                                                        {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute' }}>กรุณาเลือกล็อต</span>}

                                                    </td >
                                                    <td class="text-center"> {CalQtySack(x?.ItemNo?.Option2, +x.Qty.toString().replaceAll(',', '')).toLocaleString()}</td>
                                                    {!id && <td class="text-center">
                                                        {x?.Balance?.toLocaleString()}
                                                    </td >}
                                                    <td class="text-center">
                                                        <TextField value={x?.Qty.toLocaleString()} size='small' fullWidth variant='outlined' onChange={e => {
                                                            const item = rows?.map((v, index) => {
                                                                let newValue = e.target.value.replace(/,/g, "");
                                                                let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                                v.Qty = i === index ? abc : v?.Qty;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }} />
                                                    </td>

                                                    <td>

                                                        <TextField sx={{ background: id ? '#e9ecef' : '#fff' || x?.WarehouseNo?.WarehouseName && x?.ZoneNo?.ZoneName ? '#e9ecef' : '#fff' }} InputProps={{
                                                            readOnly: id ? true : false
                                                        }} value={x?.WarehouseNo?.WarehouseName && x?.ZoneNo?.ZoneName ? `${x?.WarehouseNo?.WarehouseName} / ${x?.ZoneNo?.ZoneName}` : ''} size='small' fullWidth variant='outlined' />

                                                    </td>

                                                    <td class="text-center">
                                                        {x?.ItemNo?.SalePrice}
                                                    </td>
                                                    <td class="text-center"> {parseFloat(x?.CostPrice).toFixed(2)
                                                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                                    </td>

                                                    <td>
                                                        <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />
                                                    </td >
                                                </tr >
                                            ))}


                                        </tbody >}
                                </table >
                            </div >


                        </div >
                        <hr class="chr" />
                        <div class="row mt-4">

                            <div class="col-12">
                                <Button onClick={() => navigate(-1)} variant='outlined'
                                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                                    sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                                {!detail || (detail && detail?.Status !== StockStatus.Inactive) ?
                                    <Button variant='contained' onClick={() => {
                                        if (!adjustDate) {
                                            setAdjustDateError(true)
                                        }

                                        if (rows?.filter((x) => !x?.ItemNo)) {
                                            const item = rows?.map((v, index) => {
                                                v.ItemError = v.ItemNo ? false : true
                                                return v;

                                            });
                                            setRows([...item]);
                                        }
                                        if (rows?.filter((x) => x?.Lot?.length < 3)) {
                                            const item = rows?.map((v, index) => {
                                                v.LotGenError = v?.Lot?.length === 3 ? false : true
                                                return v;

                                            });
                                            setRows([...item]);
                                        }
                                        if (rows?.filter((x) => x?.Year?.length < 2)) {
                                            const item = rows?.map((v, index) => {
                                                v.YearError = v?.Year?.length === 2 ? false : true
                                                return v;

                                            });
                                            setRows([...item]);
                                        }

                                        if (adjustDate && rows?.filter((x) => !x?.ItemNo).length === 0 && rows?.filter((x) => x?.Lot?.length < 3).length === 0 && rows?.filter((x) => x?.Year?.length < 2).length === 0) {
                                            setOpen(true)
                                        }
                                    }} sx={{ width: '130px', fontSize: '14px' }}> บันทึก</Button> : null}
                                {detail && detail?.Status !== StockStatus.Inactive && <Button variant='contained' color='error' onClick={() => handleSubmit(StockStatus.Inactive)} sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }}>ยกเลิก</Button>}
                            </div >
                        </div >
                    </div >
                </form >
            </Page >
            <ConfirmPrint title={'บันทึกรายการปรับปรุงยอดสำเร็จ'} download={downloadAdjust} open={openP} setOpen={setOpenP} loadingPDF={loadingPDF} linkTo='/stock/stock-adjust/add' />

            <ConfirmDialogAdjust open={open} setOpen={setOpen} rows={rows} handleAdd={handleSubmit} adjust={detail} adjustType={isAddedType} loadingSubmit={loadingSubmit} />

        </div >
    )
}
